<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'serieProposalModule.proposalDetails' | translate }}
      <span *ngIf="serieProposalId$ | async">
        ( {{ serieProposalId$ | async }} )
      </span>
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="card-body" *ngIf="serieProposal$ | async as serieProposal">
    <serie-proposal-form-general
      *ngIf="!fromInitialRequest"
      [serieProposal]="serieProposal"
      [isFromModal]="isModal"
      (onCloseModal)="closeModal()"
    >
    </serie-proposal-form-general>

    <serie-proposal-initial-request-general-tab
      *ngIf="fromInitialRequest"
      [serieProposal]="serieProposal"
      [isFromModal]="isModal"
      (onCloseModal)="closeModal()"
    >
    </serie-proposal-initial-request-general-tab>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
